export default __webpack_public_path__ + "static/cipfa-3daf59dd1de5199d4215caad6accb1cd.png";